module.exports = __webpack_public_path__ + "images/09bc3527.logo52@2x.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo52@2x.png
// module id = 263
// module chunks = 0